import { YoutubeSetting } from "../interface/youtubeSetting";

export const YOUTUBE_GET_INIT = "YOUTUBE_GET_INIT";
export const YOUTUBE_GET_SUCCESS = "YOUTUBE_GET_SUCCESS";
export const YOUTUBE_BIND_SUCCESS = "YOUTUBE_BIND_SUCCESS";
export const YOUTUBE_UNBIND_SUCCESS = "YOUTUBE_UNBIND_SUCCESS";
export const YOUTUBE_SET_DIRECT_POST_DRAFT = "YOUTUBE_SET_DIRECT_POST_DRAFT";
export const YOUTUBE_RESET_DIRECT_POST_DRAFT = "YOUTUBE_RESET_DIRECT_POST_DRAFT";

export type YoutubeVisibility = "public" | "unlisted" | "private";

export interface YoutubeDirectPostDraft {
  title: string;
  category: string;
  tags: string;
  visibility: YoutubeVisibility;
  madeForKids: boolean;
  notifySubscribers: boolean;
}

export const initialYoutubeDirectPostDraft: YoutubeDirectPostDraft = {
  title: "",
  category: "22",
  tags: "",
  visibility: "public",
  madeForKids: false,
  notifySubscribers: true,
};

export const getYoutubeInitAction = () => ({ type: YOUTUBE_GET_INIT } as const);

export const getYoutubeSuccessAction = (payload: {
  settings: YoutubeSetting | null;
}) => ({ type: YOUTUBE_GET_SUCCESS, payload } as const);

export const bindYoutubeSuccessAction = (payload: {
  settings: YoutubeSetting;
}) => ({ type: YOUTUBE_BIND_SUCCESS, payload } as const);

export const unbindYoutubeSuccessAction = () =>
  ({ type: YOUTUBE_UNBIND_SUCCESS } as const);

export const setYoutubeDirectPostDraftAction = (payload: {
  draft: Partial<YoutubeDirectPostDraft>;
}) => ({ type: YOUTUBE_SET_DIRECT_POST_DRAFT, payload } as const);

export const resetYoutubeDirectPostDraftAction = () =>
  ({ type: YOUTUBE_RESET_DIRECT_POST_DRAFT } as const);

export type YoutubeApiAction =
  | ReturnType<typeof getYoutubeInitAction>
  | ReturnType<typeof getYoutubeSuccessAction>
  | ReturnType<typeof bindYoutubeSuccessAction>
  | ReturnType<typeof unbindYoutubeSuccessAction>
  | ReturnType<typeof setYoutubeDirectPostDraftAction>
  | ReturnType<typeof resetYoutubeDirectPostDraftAction>;
